/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SortLabelsRequestLabelsInnerFromJSON, SortLabelsRequestLabelsInnerToJSON } from './SortLabelsRequestLabelsInner';
export function SortLabelsRequestFromJSON(json) {
    return SortLabelsRequestFromJSONTyped(json, false);
}
export function SortLabelsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        labels: !exists(json, 'labels')
            ? undefined
            : json['labels'].map(SortLabelsRequestLabelsInnerFromJSON)
    };
}
export function SortLabelsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        labels: value.labels === undefined ? undefined : value.labels.map(SortLabelsRequestLabelsInnerToJSON)
    };
}
